/**
 * Checks whether the supplied data represents an error response from the backend.
 *
 * @param data any object
 * @returns {*|boolean} true when the data represents an error, false otherwise
 */
export function isError(data) {
  return data.status && (data.status > 400 || data.status < 500);
}
